import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Credit, CreditType, UserCreditsViewModel } from '../models';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ValueService, LogService } from '@oa/shared-core';

@Injectable({
  providedIn: 'root'
})
export class CreditService implements OnDestroy {
  private readonly _componentName = 'CreditService';

  /**
   * Private field for verbose logging
   */
  private _verboseLogging = false;

  /**
   * Private subscription for router events
   */
  private routerEvent$: Subscription;

  /**
   * Is verbose logging enabled
   */
  private get verboseLogging(): boolean {
    return this.log.verboseLogging || this._verboseLogging;
  }

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private valueService: ValueService,
    private log: LogService
  ) {
    this.subscribeRouterEvents();
  }

  /**
   * Called once, before the instance is destroyed.
   */
  ngOnDestroy(): void {
    if (this.routerEvent$) {
      this.routerEvent$.unsubscribe();
    }
  }

  getTypes() {
    return this.http.get<CreditType[]>('credit/types');
  }
  get() {
    return this.http.get<UserCreditsViewModel>('credit');
  }

  /**
   * Gets the user credit balance
   * @param userId
   */
  getUserCreditBalance(userId: number) {
    if (this.verboseLogging) {
      console.log(`${this._componentName}.getUserCreditBalance() userId=${userId}`);          
    }    

    return this.http.get<UserCreditsViewModel>(`credit/balance/${userId}`);
  }

  getForUserById(id: number) {
    return this.http.get<UserCreditsViewModel>(`credit/${id}`);
  }

  /**
   * Adds a new credit to an existing user account.
   * @param credit
   */
  public add(credit: Credit) {
    // JPC: why put and not post????
    return this.http.put('credit', credit);
  }

  public delete(credit: Credit) {
    return this.http.delete(`credit/${credit.id}`);
  }

  /**
   * Subscribes to Router Events and sets the _verboseLogging flag
   */
  private subscribeRouterEvents() {
    this.routerEvent$ = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // console.log(`${this._componentName}.CTOR router.events NavigationEnd:`, event);

        // console.log(
        //   `${this._componentName}.CTOR router.events NavigationEnd route.snapshot.queryParamMap=`,
        //   this.route.snapshot.queryParamMap
        // );

        if (this.route.snapshot.queryParamMap.has('verboseLogging')) {
          if (this.valueService.getBoolean(this.route.snapshot.queryParamMap.get('verboseLogging')) == true) {
            this._verboseLogging = true;
          } else {
            this._verboseLogging = false;
          }
        }
      }
    });
  }
}
